import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { KYNDO_ADDRESS } from "../lib/chain";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <span className="footer-wordmark">kyndo.</span>
        <p>Markets move. Good follows.</p>
        <div>
          <Link to="/about">About & contracts</Link>
          {KYNDO_ADDRESS && (
            <a
              href={`https://basescan.org/address/${KYNDO_ADDRESS}`}
              target="_blank"
              rel="noreferrer"
            >
              Launchpad <ArrowUpRight size={14} />
            </a>
          )}
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Kyndo. Built on Base.</p>
        <span>Unaudited software. Tokens carry risk.</span>
      </div>
    </footer>
  );
}
